(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-dual-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reveal = (root) => {
      const scope = root || document;
      const items = scope.querySelectorAll('[data-cdb-reveal]');
      if (!items.length) return;

      // In the theme editor (or without IntersectionObserver) show everything immediately,
      // so live re-renders after picking an image don't leave banners hidden.
      const showNow =
        (window.Shopify && window.Shopify.designMode) ||
        !('IntersectionObserver' in window);

      if (showNow) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      items.forEach((item) => observer.observe(item));
    };

    reveal();

    // Re-run when a section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
